/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Password_SavedInputs */

const vi_einvoice_settings_password_saved = /** @type {(inputs: Einvoice_Settings_Password_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu — để trống nếu không đổi`)
};

/**

* @param {Einvoice_Settings_Password_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_password_saved = /** @type {((inputs?: Einvoice_Settings_Password_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Password_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_password_saved(inputs)
});